/**
 * @desc 门店列表
 */

import { RequestConfig, request } from 'umi';
export interface Params {
  /** phone_numbers */
  phone_numbers: Array<string>;
}

function req(params: Params, config: Parameters<typeof request>[1] = {}) {
  return request<
    defs.store.GeneralHttpResponse<Array<defs.store.StoreInfoDTO>>
  >(`/storeapi/inner/stores`, {
    params,
    method: 'get',
    ...(config || {}),
  });
}
req.req = {} as Parameters<typeof req>[0];
req.res = {} as defs.store.GeneralHttpResponse<Array<defs.store.StoreInfoDTO>>;
export default req;
